module.exports = __webpack_public_path__ + "static/media/Truss-Beverages-Terms-of-Use---Website---EN_May-2020.1f114bf7.pdf";